export default {
  feedback: {
    usage_threshold: 'Importo minimo del carrello per questa promo (escluse spese di consegna)',
    promo_code_added: 'Codice promo applicato',
    promo_code_removed: 'Codice promo {{code}} rimosso',
  },
};
